import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {
  useSourcingVehicleDetailQuery,
  useSourcingVehicleLocationsQuery,
  SourcingVehicleLocationsApiArg,
} from '@dms/api/core';
import {CountryAlpha3CodeEnum} from '@dms/api/shared';

type MapPreviewOptions = Pick<SourcingVehicleLocationsApiArg, 'currency' | 'pricingStrategy'> & {
  isMapView: boolean;
  isEditing: boolean;
  classifiedsFilterBody: SourcingVehicleLocationsApiArg['body'] | null;
  savedMapPreviewAdId: string | null | undefined;
  country: CountryAlpha3CodeEnum | undefined;
};

export function useAllOffersMapPreview(options: MapPreviewOptions) {
  const {
    isMapView,
    isEditing,
    classifiedsFilterBody,
    savedMapPreviewAdId,
    country,
    currency,
    pricingStrategy,
  } = options;
  const {data: mapLocations} = useSourcingVehicleLocationsQuery(
    isMapView && !isEditing && isNotNil(classifiedsFilterBody)
      ? {body: classifiedsFilterBody, currency, pricingStrategy}
      : skipToken
  );
  const mapCandidateAdId =
    isNotNil(savedMapPreviewAdId) &&
    (mapLocations?.items.some(({adId}) => adId === savedMapPreviewAdId) ||
      mapLocations?.missingLocationAdIds?.includes(savedMapPreviewAdId))
      ? savedMapPreviewAdId
      : null;
  const {error: mapCandidateError} = useSourcingVehicleDetailQuery(
    isNotNil(mapCandidateAdId)
      ? {
          externalId: mapCandidateAdId,
          currency,
          buyerCountry: country,
          pricingStrategy,
        }
      : skipToken
  );
  const mapPreviewAdId =
    mapCandidateError && 'status' in mapCandidateError && mapCandidateError.status === 404
      ? null
      : mapCandidateAdId;
  return mapPreviewAdId;
}
